export default __webpack_public_path__ + "static/media/bg3.4d8c0716.png";